import React from 'react';
import { IconContext } from 'react-icons';
import { MdGamepad } from 'react-icons/md';
import { SiTheconversation } from 'react-icons/si';
import { FaPeopleGroup } from 'react-icons/fa6';
import { IoLibrary } from 'react-icons/io5';
import SidebarIcon from './SidebarIcon';
import { NavLink } from 'react-router-dom';
import { GrGallery } from "react-icons/gr";
import { FaMicroscope } from "react-icons/fa";

const Sidebar: React.FC = () => {
    return (
        <div className='z-50'>
            <IconContext
                value={{ className: 'react-icons' }}
            >
                <nav
                    className='hidden md:fixed md:flex flex-col w-16 h-full p-1 m-0 space-y-1 text-white bg-gray-900 border-l shadow-xl lg:space-y-2 lg:w-20 2xl:w-24 sm:p-2 border-l-ghColorPrimary-600 shadow-ghColorPrimary-100'
                    aria-label="Main navigation"
                >
                    <NavLink
                        to='/'
                        end
                        className={({ isActive }) => (isActive ? 'active' : undefined)}
                        aria-label="Navigate to Home page"
                    >
                        {({ isActive }) => (
                            <SidebarIcon
                                icon={<MdGamepad />}
                                text='Home'
                                aria-current={isActive ? 'page' : undefined}
                            />
                        )}
                    </NavLink>
                    <NavLink
                        to='/about-project'
                        aria-label="Navigate to The Game page"
                    >
                        {({ isActive }) => (
                            <SidebarIcon
                                icon={<SiTheconversation />}
                                text='About Project'
                                aria-current={isActive ? 'page' : undefined}
                            />
                        )}
                    </NavLink>
                    <NavLink
                        to='/team'
                        aria-label="Navigate to People page"
                    >
                        {({ isActive }) => (
                            <SidebarIcon
                                icon={<FaPeopleGroup />}
                                text='Team'
                                aria-current={isActive ? 'page' : undefined}
                            />
                        )}
                    </NavLink>
                    <NavLink
                        to='/papers'
                        aria-label="Navigate to Publications page"
                    >
                        {({ isActive }) => (
                            <SidebarIcon
                                icon={<IoLibrary />}
                                text='Papers'
                                aria-current={isActive ? 'page' : undefined}
                            />
                        )}
                    </NavLink>
                    <NavLink
                        to='/reports-policies'
                        aria-label="Navigate to Reports & Policies page"
                    >
                        {({ isActive }) => (
                            <SidebarIcon
                                icon={<FaMicroscope />}
                                text='Reports & Policies'
                                aria-current={isActive ? 'page' : undefined}
                            />
                        )}
                    </NavLink>
                    <NavLink
                        to='/gallery&media'
                        aria-label="Navigate to Gallery & Media page"
                    >
                        {({ isActive }) => (
                            <SidebarIcon
                                icon={<GrGallery />}
                                text='Gallery & Media'
                                aria-current={isActive ? 'page' : undefined}
                            />
                        )}
                    </NavLink>
                </nav>
            </IconContext>
        </div>
    );
};

export default Sidebar;

